import React, { SetStateAction } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from '@material-ui/core';
import { ExpandMore, Add } from '@material-ui/icons';
import { useStyles } from './styles';
import ViaForm from './ViaForm';
import { generateId } from '../../pages/AddEngineering/utils';
import { ViaObject } from '../../@types/incidentTypes';

const initialVia: ViaObject = {
  index: 0,
  'Condição da Calçada': 'Não informado',
  Nome: '',
  'Sinalização Vertical': 'Não informado',
  'Condição da Pista': 'Não informado',
  'Sinalização Horizontal': 'Não informado',
  'Faixa para Sentido': 'Não informado',
  'Alinhamento Vertical': 'Não informado',
  'Obra de Arte': 'Não informado',
  'Tipo do Pavimento': 'Não informado',
  'Alinhamento Horizontal': 'Não informado',
  'Separação Central': 'Não informado',
  'Tipo da Pista': 'Não informado',
  'Obras na Pista': 'Não informado',
  _localId: '',
};

interface IProps {
  driverVias: ViaObject[];
  setDriverVias: React.Dispatch<SetStateAction<ViaObject[]>>;
  adresses: { address1: string; address2: string };
  requiredFields: { key: string; message: string }[];
  desabilitado?: boolean;
}

const ViaFormGroup: React.FC<IProps> = ({
  driverVias,
  setDriverVias,
  requiredFields,
  adresses,
  desabilitado,
}) => {
  const classes = useStyles();

  const addNewVia = () => {
    const list = [...driverVias];
    if (list.length === 0 && adresses.address1) {
      list.push({
        ...initialVia,
        index: driverVias.length,
        _localId: generateId(),
        Nome: adresses.address1,
      });
      setDriverVias(list);
      return;
    }
    if (list.length === 1 && adresses.address2) {
      list.push({
        ...initialVia,
        index: driverVias.length,
        _localId: generateId(),
        Nome: adresses.address2,
      });
      setDriverVias(list);
      return;
    }

    list.push({ ...initialVia, index: driverVias.length, _localId: generateId() });
    setDriverVias(list);
  };

  const deleteVia = (index: number) => {
    const list = [...driverVias]
      .filter((item) => {
        return item.index !== index;
      })
      .map((item, i) => {
        return { ...item, index: i };
      });
    setDriverVias(list);
  };

  const changeViasState = (via: ViaObject) => {
    const list = [...driverVias];
    list[via.index] = via;
    setDriverVias(list);
  };

  return (
    <Accordion className={classes.accordionContainer}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Vias</Typography>{' '}
      </AccordionSummary>
      <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <div className={classes.addButtonContainer}>
            <Button
              color="default"
              variant="outlined"
              endIcon={<Add />}
              className={classes.addButton}
              onClick={() => addNewVia()}
              disabled={desabilitado}
            >
              Adicionar
            </Button>
          </div>

          {driverVias.map((item) => {
            return (
              <ViaForm
                key={item._localId}
                viaObject={item}
                deleteVia={deleteVia}
                changeViasState={changeViasState}
                requiredFields={requiredFields}
                desabilitadoViaForm={desabilitado}
              />
            );
          })}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default ViaFormGroup;
